'use client'

import { Thermometer } from 'lucide-react'
import { useTheme } from '@/contexts/ThemeContext'

interface BuddyTemperatureProps {
  temperature: number
  className?: string
  variant?: 'card' | 'inline'
}

export default function BuddyTemperature({ temperature, className = '', variant = 'card' }: BuddyTemperatureProps) {
  const { theme } = useTheme()

  // 온도에 따른 텍스트 색상 (숫자만 표시)
  const getTemperatureTextColor = (temp: number) => {
    if (temp < 33) {
      return 'text-blue-500'
    } else if (temp < 36) {
      return 'text-blue-500'
    } else if (temp < 38) {
      return 'text-green-500'
    } else if (temp < 40) {
      return 'text-yellow-500'
    } else if (temp < 55) {
      return 'text-orange-500'
    } else {
      return 'text-red-500'
    }
  }

  // inline 버전 (프로필 상단 카드용)
  if (variant === 'inline') {
    return (
      <div className={`flex items-center gap-1.5 xxs:gap-2 ${className}`}>
        <Thermometer className="w-3.5 xxs:w-4 xs:w-5 h-3.5 xxs:h-4 xs:h-5 flex-shrink-0 text-white/70" />
        <span className="text-xs xxs:text-sm xs:text-base text-white/80">버디 온도</span>
        <span className={`text-sm xxs:text-base xs:text-lg font-bold ${getTemperatureTextColor(temperature)}`}>
          {temperature.toFixed(1)}°C
        </span>
      </div>
    )
  }

  // card 버전 (기본)
  return (
    <div className={`${className}`}>
      <div className={`rounded-xl p-4 xxs:p-5 xs:p-6 ${
        theme === 'light'
          ? 'bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-200'
          : 'bg-gray-800 border border-gray-700'
      }`}>
        {/* 헤더 */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 xxs:gap-2.5 xs:gap-3">
            <Thermometer className={`w-5 xxs:w-6 xs:w-7 h-5 xxs:h-6 xs:h-7 ${
              theme === 'light' ? 'text-blue-600' : 'text-blue-400'
            }`} />
            <h3 className={`text-sm xxs:text-base xs:text-lg font-bold ${
              theme === 'light' ? 'text-gray-800' : 'text-white'
            }`}>
              버디 온도
            </h3>
          </div>

          {/* 온도 값 (숫자만 색깔로 표시) */}
          <div className={`text-2xl xxs:text-3xl xs:text-4xl font-bold ${getTemperatureTextColor(temperature)}`}>
            {temperature.toFixed(1)}°C
          </div>
        </div>
      </div>
    </div>
  )
}
